/* eslint-disable no-underscore-dangle */
import {
  DragAndDropOutlineIcon,
  Icon,
  TrashOutlineIcon,
} from '@fountain/ripple/icon';
import { Grid } from '@material-ui/core';
import { PartnerRuleAttributes } from 'api-clients/monolith';
import React, { FC } from 'react';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { useIntl } from 'react-intl';

import { StageSettingCard } from 'containers/WorkflowEditor/components/StageSettingCard';

import { PartnerAction } from '../PartnerAction';
import { PartnerCondition } from '../PartnerCondition';
import { PartnerRuleProps } from '../types';
import { messages } from './messages';
import { useStyles } from './styles';

export interface RuleCardProps {
  ruleId: string;
  index: number;
  rule: PartnerRuleAttributes;
  setPartnerRules: React.Dispatch<React.SetStateAction<PartnerRuleProps>>;
  errors?: {
    [key: string]: string[];
  };
  onDeleteRule: (ruleId: string | number) => void;
  dragHandleProps?: DraggableProvidedDragHandleProps | null;
}

export const PartnerRuleCard: FC<RuleCardProps> = React.memo(
  ({
    rule,
    index,
    ruleId,
    setPartnerRules,
    onDeleteRule,
    errors,
    dragHandleProps,
  }) => {
    const styles = useStyles();

    const intl = useIntl();

    const action = rule.action_attributes;
    const condition = rule.condition_attributes;

    const titleText = intl.formatMessage(messages.ruleNumber, {
      number: index + 1,
    });

    return (
      <Grid className={styles.ruleCardContainer}>
        <StageSettingCard
          title={
            dragHandleProps ? (
              <Grid container alignItems="center">
                <span
                  {...dragHandleProps}
                  className={styles.dragHandle}
                  aria-label={intl.formatMessage(messages.dragRule, {
                    number: index + 1,
                  })}
                >
                  <Icon
                    icon={DragAndDropOutlineIcon}
                    size="lg"
                    color="inherit"
                    className={styles.dragIcon}
                  />
                </span>
                {titleText}
              </Grid>
            ) : (
              titleText
            )
          }
          icon={
            <Icon
              icon={TrashOutlineIcon}
              size="sm"
              color="inherit"
              className={styles.trashcanIcon}
            />
          }
          buttonText={intl.formatMessage(messages.deleteRule)}
          variant="button"
          onClick={() => onDeleteRule(ruleId)}
        >
          <Grid>
            <div className={styles.paddingBottom}>
              <Grid>
                <PartnerCondition
                  key={ruleId}
                  ruleId={ruleId}
                  condition={condition}
                  setPartnerRules={setPartnerRules}
                  errors={errors}
                />
              </Grid>
            </div>

            <Grid>
              <PartnerAction
                key={ruleId}
                action={action}
                ruleId={ruleId}
                setPartnerRules={setPartnerRules}
                errors={errors}
              />
            </Grid>
          </Grid>
        </StageSettingCard>
      </Grid>
    );
  },
);
